import { D_INV22G, TOKEN, USER, USERNAME } from "constants/api/localStorage";
import { getLocalStorageOrCookie } from "utils/getLocalStorageOrCookie";

export function InvalidateConnectionData() {
  if (getLocalStorageOrCookie(USER)) {
    if (localStorage.getItem(USER)) {
      localStorage.removeItem(USER);
    } else {
      document.cookie =
        USER +
        "=" +
        getLocalStorageOrCookie(USER) +
        "; expires=" +
        Date.now +
        "; path=/;";
    }
  }

  if (localStorage.getItem(USERNAME)) {
    localStorage.removeItem(USERNAME);
  }

  if (getLocalStorageOrCookie(D_INV22G)) {
    if (localStorage.getItem(D_INV22G)) {
      localStorage.removeItem(D_INV22G);
    } else {
      document.cookie =
        D_INV22G +
        "=" +
        getLocalStorageOrCookie(D_INV22G) +
        "; expires=" +
        Date.now +
        "; path=/;";
    }
  }

  if (getLocalStorageOrCookie(TOKEN)) {
    if (localStorage.getItem(TOKEN)) {
      localStorage.removeItem(TOKEN);
    } else {
      document.cookie =
        TOKEN +
        "=" +
        getLocalStorageOrCookie(TOKEN) +
        "; expires=" +
        Date.now +
        "; path=/;";
    }
  }
}
